import {Message} from "element-ui";
import qs from 'qs'
import gql from "@/graphql/apollo";

const state = {
    projects:[],
    projectDetail:{},
    projectLoading:true,
    appDetail:{},
    detailLoading: true
}
const getters = {
    nowLoading: () => {
        return state.projectLoading;
    }
}
const actions = {
    getSetting({state, commit}, obj) {
        state.projectLoading = true;
        state.projects = [];
        let str = gql.appProjects;
        let variables = {};
        let nowClient = 'appcenter';
        let key = 'userAppProjects';

        if(obj.noLogin){
            str = gql.anonymityAppProjects;
            variables = { tenant: window.commonApi.TENANT}
            nowClient = 'nologin'
            key = 'anonymityAppProjects'
        }
        apolloProvider.clients[nowClient].query({
            query: str,
            variables,
            fetchPolicy: "no-cache",
        }).then(res => {
            let data = res.data[key];
            commit('updateProjects', data)
        }).catch(error => {
            // console.log(error);
        }).finally((res)=>{
            state.projectLoading = false;
        })
    },
    getAppDetail({state, commit}, {id}) {
        state.detailLoading = true;
        state.appDetail = {};
        apolloProvider.clients.appcenter.query({
            query: gql.app,
            variables: {id},
            client: 'appcenter',
            fetchPolicy: "no-cache",
        }).then(res => {
            let data = res.data.app || {};
            commit('updateDetail', data)
        }).catch(error => {
            // console.log(error);
        }).finally((res)=>{
            state.detailLoading = false;
        })
    }
}

const mutations = {
    updateProjects(state, json) {        
        let jsons = Object.assign([],json).filter(t=> t.type && t.type !== 'RECOMMENDATION');
        
        console.log(jsons)
        state.projects = jsons.sort((a,b)=>{
            let aS = a.sort == null ? Infinity : a.sort;
            let bS = b.sort == null ? Infinity : b.sort;

            return aS - bS;
        })

    },
    updateDetail(state, json) {
        state.appDetail = json;
        state.detailLoading = false
    },
    nowProjectDetail(state, json){
        state.projectDetail = json;
        console.log(state.projectDetail, '--------')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/appProjects.js